import { REPORT_LOADER_START, REPORT_LOADER_STOP } from "./types";

const initialState = {
  loading: false,
};

const data360LiveReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case REPORT_LOADER_START:
      return {
        ...state,
        loading: true,
      };

    case REPORT_LOADER_STOP:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};

export default data360LiveReportReducer;
